import CryptoJS from "crypto-js";

let prodMode = true;

export const ENDPOINT = prodMode
  ? "https://api.theexperience.co"
  : "https://dev-api.theexperience.co";

export const BHX_PIXEL_ID = "630019181040627";

export const BUCKETLIST_PIXEL_ID = "751008092884896";

export const BHX_ACCESS_TOKEN =
  "EAADUBkgdyOQBAJgn3ByGoXUpmPEgEhEnJYbs69CF0HfUJXnQSrxyUKAp6aYhvbhSJC0DUT7DGCZBCVZAqgFZBBZBwgAPeC3wVdf4lfwFlXead50LClxsGZCwwduqpVQ8khmOFtqMLu8ZCiijZClKRZAb8CqemcVZBZA0iDJE2c6Fk1n1iYiCZBA6sXp";

export const BUCKETLIST_ACCESS_TOKEN =
  "EAADUBkgdyOQBALeKxHTlSeLv6SyrbbM8xceMVaLuaL8oyaofJvTz8S38lAR2AxknQ2mjOvXdMPFQX8wP24xNe4oW6vGeyn8z94ERrpSofzgxPueGwBZAikAiVs1fF36zZBbE68C82uueiUJPSjmNbzDJaDwMZCzCP2ZAHpe3hWjEoe0t4qeD";
export function suppressConsoleLogs() {
  if (process.env.NODE_ENV === "production") {
    for (let method of ["log", "warn", "info", "debug"]) {
      console[method] = () => {}; // Replace console methods with no-op
    }
  }
}

export const hashData = (data) => {
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Base64); // Hash using SHA-256 and encode in Base64
};

export const getQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const project = urlParams.get("project");
  const otherParams = {};

  // Store all params except 'project'
  urlParams.forEach((value, key) => {
    if (key !== "project") {
      otherParams[key] = value;
    }
  });

  return { project, otherParams };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
